import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { STORAGE_KEYS } from '@/constants';
import type { UiState } from '@/types';

function storedTheme(): UiState['theme'] {
  try {
    const value = localStorage.getItem(STORAGE_KEYS.theme);
    if (value === 'light' || value === 'dark') return value;
  } catch {
    // Storage unavailable; fall through to following the system.
  }
  return 'system';
}

const initialState: UiState = {
  theme: storedTheme(),
  sidebarOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    themeChanged(state, action: PayloadAction<UiState['theme']>) {
      state.theme = action.payload;
    },
    sidebarToggled(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    sidebarClosed(state) {
      state.sidebarOpen = false;
    },
  },
});

export const { themeChanged, sidebarToggled, sidebarClosed } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
